module.exports = __webpack_public_path__ + "img/D2.9e845a3f.svg";